import { render, staticRenderFns } from "./scrollNews.vue?vue&type=template&id=2d9c728c&scoped=true&"
import script from "./scrollNews.vue?vue&type=script&lang=js&"
export * from "./scrollNews.vue?vue&type=script&lang=js&"
import style0 from "./scrollNews.vue?vue&type=style&index=0&id=2d9c728c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c728c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9c728c')) {
      api.createRecord('2d9c728c', component.options)
    } else {
      api.reload('2d9c728c', component.options)
    }
    module.hot.accept("./scrollNews.vue?vue&type=template&id=2d9c728c&scoped=true&", function () {
      api.rerender('2d9c728c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subject/preview/scrollNews.vue"
export default component.exports